//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AMTS_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/AMTS_info.vue